const Image360 = {

    init: function(imgList) {

        const stages = document.querySelectorAll('img.image360_viewer');
        const cursorGrab = 'grab';
        const cursorGrabbing = 'grabbing';


        for (let i = 0; i < stages.length; i++) {
            const stage = stages[i];

            const vehicle = stage.getAttribute('data-vehicle');
            const images = [],
                totalFrames = imgList[vehicle].length
            ;
            let currentFrame = 0,
                rotate360Interval = null,
                start_x = null
            ;

            for (let j = 0; j < totalFrames; j++) {
                const img = document.createElement('img');
                img.src = imgList[vehicle][j];
                images[j] = img;
            }
            rotate360();

            function rotate360() { // jshint ignore:line
                document.body.style.cursor = 'none';
                update360(0);

                rotate360Interval = setInterval(function() {
                    if (currentFrame === totalFrames - 1) {
                        clearInterval(rotate360Interval);
                        // addNavigation();
                    }
                    update360(1);
                }, 25);
            }

            function update360(dir) { // jshint ignore:line
                currentFrame += dir;
                if (currentFrame < 0) currentFrame = totalFrames - 1;
                else if (currentFrame > totalFrames - 1) currentFrame = 0;
                stage.src = images[currentFrame].src;
            }

            // add navigation
            stage.addEventListener('mouseover', function(event) { // jshint ignore:line
                document.body.style.cursor = 'grab';
            });

            stage.addEventListener('mouseout', function(event) { // jshint ignore:line
                document.body.style.cursor = 'auto';
            });

            stage.addEventListener('mousedown', function(event) { // jshint ignore:line
                event.preventDefault();
                start_x = event.screenX;
                stage.addEventListener('mousemove', function mouseMoved(event) {
                    const dx = event.screenX - start_x;
                    const abs_dx = Math.abs(dx);

                    if (abs_dx > 5) {
                        update360(dx / abs_dx);
                        start_x = event.screenX;
                    }
                    stage.addEventListener('mouseup', function(event) {
                        stage.removeEventListener('mousemove', mouseMoved, false);
                        stage.onMouseUp = null;
                        document.body.style.cursor = 'grab';
                    });
                });
                document.body.style.cursor = cursorGrabbing;
            });

            stage.addEventListener('touchstart', function(event) { // jshint ignore:line
                event.preventDefault(); console.log(event);
                start_x = parseInt(event.changedTouches[0].pageX); console.log(start_x);
                stage.addEventListener('touchmove', function mouseMoved(event) {
                    const dx = parseInt(event.changedTouches[0].pageX) - start_x;
                    const abs_dx = Math.abs(dx);

                    if (abs_dx > 5) {
                        update360(dx / abs_dx);
                        start_x = parseInt(event.changedTouches[0].pageX);
                    }
                    stage.addEventListener('touchend', function(event) {
                        stage.removeEventListener('touchmove', mouseMoved, false);
                        stage.onMouseUp = null;
                        document.body.style.cursor = 'grab';
                    });
                });
                document.body.style.cursor = cursorGrabbing;
            });
            document.body.style.cursor = 'auto';
        }
    }

};
